import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import Browser from '@wetransfer/concorde-browser';

import Icon from '@component/icon';

export default class PlusCustomisation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      index: this.props.start,
      interval: null,
    };

    this.clearInterval = this.clearInterval.bind(this);
    this.clickHandler = this.clickHandler.bind(this);
    this.rotateCustomisation = this.rotateCustomisation.bind(this);
    this.updateIndex = this.updateIndex.bind(this);
  }

  componentDidMount() {
    if (!Browser.isMobile) {
      this.rotateCustomisation();
    }
  }

  componentWillUnmount() {
    this.clearInterval();
  }

  clearInterval() {
    if (this.state.interval) {
      clearInterval(this.state.interval);
    }
  }

  clickHandler() {
    this.clearInterval();
    this.updateIndex();
    this.rotateCustomisation();
  }

  rotateCustomisation() {
    const interval = setInterval(this.updateIndex, 5000);
    this.setState({ interval });
  }

  updateIndex() {
    const newIndex =
      this.state.index === this.props.previews.length - 1
        ? 0
        : this.state.index + 1;
    this.setState({ index: newIndex });
  }

  makeImage(image, className) {
    return Browser.isMobile ? (
      <img
        src={this.props.previews[this.props.mobilePreview][image]}
        alt={this.props.previews[this.props.mobilePreview].brand}
        className={className}
      />
    ) : (
      this.props.previews.map((preview, index) => (
        <CSSTransition
          in={index === this.state.index}
          timeout={500}
          classNames="plus-new__customisation"
          unmountOnExit
          key={preview.brand}
        >
          <img src={preview[image]} alt={preview.brand} className={className} />
        </CSSTransition>
      ))
    );
  }

  render() {
    const currentIndex = Browser.isMobile
      ? this.props.mobilePreview
      : this.state.index;

    return (
      <div
        className="plus-new__customisation"
        onClick={Browser.isMobile ? null : this.clickHandler}
      >
        <Icon
          type="BrowserLarge"
          subDomain={this.props.previews[currentIndex].channel}
          domain={this.props.domain}
          className="plus-new__customisation-browser"
        />
        {this.makeImage('wallpaper', 'plus-new__customisation-wallpaper')}
        <Icon
          type="Logo"
          className="plus-new__customisation-browser-logo"
          shadow={true}
          width={19}
          height={10}
        />
        <div className="plus-new__customisation-browser-navigation" />
        <Icon
          type="DownloadActive"
          className="plus-new__customisation-dowload-active"
        />
        <div className="plus-new__customisation-mail">
          <Icon
            type="MailClientSmall"
            className="plus-new__customisation-mail-client"
          />
          {this.makeImage('emailbg', 'plus-new__customisation-mail-wallpaper')}
          <Icon
            type="Logo"
            className="plus-new__customisation-mail-logo"
            shadow={true}
            width={19}
            height={10}
          />
          <Icon
            type="MailContent"
            className="plus-new__customisation-mail-content"
          />
          <h6 className="plus-new__customisation-mail-title">
            {this.props.previews[currentIndex].brand}
          </h6>
          <p className="plus-new__customisation-mail-subtitle">
            sent you some files
          </p>
          {this.makeImage('avatar', 'plus-new__customisation-mail-avatar')}
        </div>
      </div>
    );
  }
}

PlusCustomisation.propTypes = {
  start: PropTypes.number,
  previews: PropTypes.array,
  mobilePreview: PropTypes.number,
  domain: PropTypes.string,
};

PlusCustomisation.defaultProps = {
  start: 0,
};
